import { render, staticRenderFns } from "./CreateCommission.vue?vue&type=template&id=4bdf5936&scoped=true&"
import script from "./CreateCommission.vue?vue&type=script&lang=js&"
export * from "./CreateCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf5936",
  null
  
)

export default component.exports